/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EngineMeasurementRequestDto } from '../models/EngineMeasurementRequestDto';
import type { EngineMeasurementResponseDto } from '../models/EngineMeasurementResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EngineMeasurementControllerService {

    /**
     * @param id
     * @returns EngineMeasurementResponseDto OK
     * @throws ApiError
     */
    public static findEngineMeasurementById(
        id: number,
    ): CancelablePromise<EngineMeasurementResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/engine-measurements/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns EngineMeasurementResponseDto OK
     * @throws ApiError
     */
    public static updateEngineMeasurement(
        id: number,
        requestBody: EngineMeasurementRequestDto,
    ): CancelablePromise<EngineMeasurementResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/engine-measurements/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteEngineMeasurement(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/engine-measurements/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param engineId
     * @param from
     * @param to
     * @returns EngineMeasurementResponseDto OK
     * @throws ApiError
     */
    public static findEngineMeasurements(
        engineId?: number,
        from?: string,
        to?: string,
    ): CancelablePromise<Array<EngineMeasurementResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/engine-measurements',
            query: {
                'engineId': engineId,
                'from': from,
                'to': to,
            },
        });
    }

    /**
     * @param requestBody
     * @returns EngineMeasurementResponseDto OK
     * @throws ApiError
     */
    public static createEngineMeasurement(
        requestBody: EngineMeasurementRequestDto,
    ): CancelablePromise<EngineMeasurementResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/engine-measurements',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
